import * as React from 'react';
import * as Modal from '../../common/modalDialog';
import Dialog from '@material-ui/core/Dialog';
import * as Constants from '../../common/constants';
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
import ReactWebChat, { createDirectLine, createStore } from 'botframework-webchat';
import Spinner from '../../common/components/spinner/spinner';
import ChatBotService from '../../services/chatBotService';
import Growl from '../../common/components/alertMessage/growl';
import { DirectLine } from 'botframework-directlinejs';
import AuthService from '../../services/authService';
import logo01icon from "../../assets/images/logos/Logo-01-icon.png";
import * as HelperFunctions from "../../common/functions/helperFunctions";
import Translate from '../../common/functions/translate';
import logoCircle from "../../assets/images/logos/web_hi_res_512.png";
import capture from "../../assets/images/icons/filetypes/tempsnip.png";

interface IProps {
}

interface IState {
    token: any;
    isLoading: boolean;
    langId: string;
    userId: string;
}

class ChatMobileComponent extends React.Component<IProps, IState> {
    chatBotService = new ChatBotService();
    authService = new AuthService();
    growl: any;
    chat: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            token: null,
            isLoading: false,
            langId: '',
            userId: ''
        };
    }

    componentDidMount() {
        let userId = HelperFunctions.getURLParameter('userId');
        let langId = HelperFunctions.getURLParameter('langId');

        this.setState({
            isLoading: true,
            userId: userId ? userId.toString() : '',
            langId: langId ? langId.toString() : ''
        });

        this.chatBotService.getChatToken().then(
            (data: any) => {
                if (data) {
                    this.setState({
                        isLoading: false,
                        token: data
                    });
                }
            })
            .catch(error => {
                this.growl.show({ severity: 'error', summary: error.message ? error.message : 'Uncaught error' });
                this.setState({
                    isLoading: false
                });
            });
    }

    //createDirectLine({ token: token })


    shouldComponentUpdate(nextProps, nextState) {

        if (nextState.token != this.state.token) {
            return true;
        }

        if (nextState.isLoading != this.state.isLoading) {
            return true;
        }

        return false;
    }

    render() {
        const { isLoading, token } = this.state;
        let lang: string = 'bg-BG';

        if (this.state.langId && this.state.langId != '') {
            if (this.state.langId == '1') {
                lang = 'bg-BG';
            }
            if (this.state.langId == '2') {
                lang = 'en-US';
            }
        }

        const store = createStore({}, ({ dispatch }) => next => action => {
            if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
                dispatch({
                    type: 'WEB_CHAT/SEND_EVENT',
                    payload: {
                        name: 'webchat/join',
                        value: { language: window.navigator.language }
                    }
                });
            }
            return next(action);
        })

        return (
            <>
                {isLoading ? <Spinner inlineSpinner /> : null}
                <Growl ref={(el) => this.growl = el} />
                {token ?
                    <ReactWebChat
                        ref={(el) => this.chat = el}
                        locale={lang}
                        directLine={createDirectLine({ token: token })}
                        store={store}
                        styleOptions={{
                            sendTypingIndicator: true,
                            hideUploadButton: true,
                            bubbleFromUserBackground: '#2196f3',
                            bubbleFromUserTextColor: 'white',
                            bubbleBorderRadius: 10,
                            bubbleFromUserBorderRadius: 10,
                            botAvatarImage: logoCircle,
                            userAvatarImage: capture
                        }}
                        userID={this.state.userId}
                        username={lang}
                    /> : null}
            </>
        )
    }
}

export default ChatMobileComponent;